import React from 'react';
import { FormattedTag } from 'core/components';
import { LoyaltyProgram } from 'components/loyalty-program/loyalty-program';
import { Main } from 'components/main/main';
import { HeadHelmet } from 'components/head-helmet/head-helmet';
import { PAGE_NAMES } from '../../constants';

// import './loyalty.scss';

const Loyalty = () => (
  <Main>
    <HeadHelmet page={PAGE_NAMES.LOYALTY} />

    {/* <div className="loyalty-bg position-absolute w-100" /> */}
    <div className="loyalty-container mb-13">
      <FormattedTag id="loyalty-program.title" className="loyalty-title h1 text-center letter-spacing-extra d-block mb-0_5 mb-md-2 mt-9" />
      <FormattedTag tag="h3" id="loyalty-program.subtitle" className="loyalty-text text-center mx-md-auto" />
      <FormattedTag tag="p" id="loyalty-program.text" className="loyalty-text text-center mx-md-auto" />

      <LoyaltyProgram />
    </div>
  </Main>
);

export default Loyalty;
